import * as React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {Link} from "react-router";
import {stringAvatar, stringToColor} from "../../utils/color";
import MdiIcon from "../../share/components/mdi/MdiIcon.tsx";
import { mdiAccountMultiple } from "@mdi/js";
import {Session} from "../../app/slices/sessionSlice";
import Divider from '@mui/material/Divider';
import { t } from "@lingui/core/macro";

export function secondaryList(session: Session | undefined) {
    return [
        
    ]
}

export function secondaryListItems(open: boolean, session: Session | undefined, handleClick: (packageName: string) => void) {
    
    const list = secondaryList(session)
    
    if (list.length === 0) {
        return undefined    
    }
    
    return (
        <React.Fragment>
            <Divider sx={ {my: 1} }/>
            <ListItemButton
                onClick={() => handleClick('address')}
                data-testid="address"
            >
                <ListItemIcon>
                    <MdiIcon d={ mdiAccountMultiple } htmlColor="grey" />
                </ListItemIcon>
                <ListItemText primary={t`Addresses`}/>
                {open ? <ExpandLess/> : <ExpandMore/>}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    { list.map(item =>
                        <ListItemButton
                            key={item.path}
                            component={Link}
                            to={item.path}
                            data-testid={item.name}
                            aria-label={item.name}
                        >
                            <ListItemIcon>
                                <Avatar {...stringAvatar(item.label)}/>
                            </ListItemIcon>
                            <ListItemText primary={item.label}/>
                        </ListItemButton>)}
                </List>
            </Collapse>
        </React.Fragment>
    );
}
